import React from "react";

const YES_NO_NA = ["Yes", "No", "NA"];

const normalize = (v) => {
  if (v === null || v === undefined) return "";
  const s = String(v).trim();
  if (/^n\/?a$/i.test(s)) return "NA";
  if (/^yes$/i.test(s)) return "Yes";
  if (/^no$/i.test(s)) return "No";
  return s;
};

const RadioPill = ({ label, selected }) => {
  const dot = selected ? (
    <span className="inline-flex h-4 w-4 items-center justify-center rounded-full border-2 border-indigo-600">
      <span className="h-1.5 w-1.5 rounded-full bg-indigo-600" />
    </span>
  ) : (
    <span className="inline-flex h-4 w-4 rounded-full border-2 border-gray-300" />
  );

  return (
    <span
      className={`inline-flex items-center gap-2 rounded-full border px-3 py-1 text-sm ${
        selected
          ? "border-indigo-200 bg-indigo-50 text-indigo-700"
          : "border-gray-200 bg-white text-gray-700"
      }`}
    >
      {dot}
      <span>{label}</span>
    </span>
  );
};

const AnswerSelect = ({ value }) => {
  const v = normalize(value);

  // Yes/No/NA gets the radio-group treatment to match the screenshot's prototype.
  // Anything else falls back to a single pill so we don't drop unusual values.
  if (YES_NO_NA.includes(v) || v === "") {
    return (
      <div>
        <div className="text-[11px] uppercase tracking-wide text-gray-500 mb-1.5">Yes/No/NA</div>
        <div className="flex flex-wrap gap-2">
          {YES_NO_NA.map((opt) => (
            <RadioPill key={opt} label={opt} selected={v === opt} />
          ))}
        </div>
      </div>
    );
  }

  return (
    <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-50 text-indigo-700 border border-indigo-200">
      {value}
    </span>
  );
};

export default AnswerSelect;
